import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { groupLibrary } from '@packproof/ux';
import { listTransactions, type PortalTransaction } from '../api';
import { revisionsOf, workspaceOf } from '../workspace';
import { useAuth } from '../auth';
import { usePortalWorkspaceRefresh } from '../workspace-refresh';

export function LibraryPage() {
  const { user } = useAuth();
  const [items, setItems] = useState<PortalTransaction[]>([]);
  const [error, setError] = useState<string | null>(null);
  const processing = items.some((item) => workspaceOf(item).evidenceProcessing.state !== 'IDLE');

  const load = useCallback(() => {
    return listTransactions()
      .then((result) => {
        setItems(result.data);
        setError(null);
      })
      .catch((caught: unknown) => {
        setError(caught instanceof Error ? caught.message : 'Could not load PackProofs.');
      });
  }, []);

  usePortalWorkspaceRefresh(load, {
    processingState: processing ? 'FINALIZING' : 'IDLE',
    revisions: revisionsOf(items),
  });

  const grouped = user ? groupLibrary(items, (item) => workspaceOf(item).nextAction) : { active: [], completed: [] };

  return (
    <>
      <p className="eyebrow">Library</p>
      <h1>PackProofs</h1>
      <p className="lede">Your records. Next Action and Proof availability come from the same server workspace as Android.</p>
      {error ? <p className="error">{error}</p> : null}
      <section className="stack">
        {grouped.active.map((item) => (
          <Link key={item.id} className="card" to={`/packproofs/${item.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <h2>{item.title}</h2>
            <p className="meta">{workspaceOf(item).nextAction.headline}</p>
          </Link>
        ))}
      </section>
      {grouped.completed.length ? (
        <>
          <h1 style={{ marginTop: 36, fontSize: 22 }}>Completed</h1>
          <section className="stack">
            {grouped.completed.map((item) => (
              <Link
                key={item.id}
                className="card"
                to={workspaceOf(item).proof.availability === 'AVAILABLE' ? `/packproofs/${item.id}/proof` : `/packproofs/${item.id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <h2>{item.title}</h2>
                <p className="meta">{workspaceOf(item).proof.availability === 'AVAILABLE' ? 'View Proof' : workspaceOf(item).nextAction.headline}</p>
              </Link>
            ))}
          </section>
        </>
      ) : null}
    </>
  );
}
